import { useQuery } from 'react-query';
import {
  getUserInvitationRecap,
  type UserInvitationRecapResponse
} from '../../services/userService';

export function useGetInvitationRecap() {
  return useQuery<UserInvitationRecapResponse>({
    queryKey: ['userInvitationRecap'],
    queryFn: () => getUserInvitationRecap()
  });
}
